<template>
  <div class="layout layout-vr" >
    <section class="header" v-if="$slots.header">
      <slot name="header"></slot>
    </section>
    <section class="main" :class="[ovflowFlowMain]" v-if="$slots.default">
      <slot></slot>
    </section>
    <section class="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </section>
  </div>
</template>
<script>
export default {
  name: 'layout',
  props: {
    ovflowFlowMain: {
      default: 'hidden'
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../../assets/style/index';
  .layout {
    .full();
    background-color: @mainBgColor;
    display: flex;
    flex-direction: column;
    > .header {
      flex: 0 0 @header-height;
      background-color: @main-color-2;
      border-bottom: 2px @second-color-1 solid;
    }
    > .main {
      flex: auto;
      position: relative;
      &.auto {
        // overflow: auto;
		overflow-y: auto;
		overflow-x: hidden;
      }
      &.hidden {
        overflow: hidden;
      }
      &.scroll {
        overflow: scroll;
      }
    }
    > .footer {
      flex: 0 0 36px;
      background-color: @main-color-1;
    }
  }
</style>
